import { render, staticRenderFns } from "./TheBaseHeader.vue?vue&type=template&id=5dc8bdb0&scoped=true&"
import script from "./TheBaseHeader.vue?vue&type=script&lang=js&"
export * from "./TheBaseHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheBaseHeader.vue?vue&type=style&index=0&id=5dc8bdb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8bdb0",
  null
  
)

export default component.exports